export default __webpack_public_path__ + "static/media/collaborate5.16174e80.png";